import PropTypes from 'prop-types';
import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';

import LangSelect from '../../components/UserSettings/LangSelect';
import TimezoneSelect from '../../components/UserSettings/TimezoneSelect';
import UnitSelect from '../../components/UserSettings/UnitSelect';
import PressureUnitSelect from '../../components/UserSettings/PressureUnitSelect';
import UserGuideHelp from '../../components/UserSettings/UserGuideHelp';

require('./UserBlock.scss');

const userGuideFileName = 'AQS_v5.0_User_Interface_Guide.pdf';

export default function UserBlock(props, context) {
  const { user, local, downloadFile } = props;
  const [aboutOpen, setAboutOpen] = React.useState(false);

  const projectTimezone = useSelector((state) => {
    if (!state.leaksList || !state.leaksList.projectsList) {
      return null;
    }
    const selectedProject = state.leaksList.selectedProject;
    if (!selectedProject) {
      return null;
    }
    const projectIndex =
      state.leaksList.projectsList.projectIndexMap[selectedProject];
    if (projectIndex === undefined) {
      return null;
    }
    const project = state.leaksList.projectsList.items[projectIndex];
    return project ? project.TimezoneName : null;
  });

  const currentLang = useSelector((state) => state.i18nState.lang || 'en');

  return (
    <div className='userblock'>
      <span>{context.t('hello_username', { userName: user.name })}</span>
      {JSON.parse(process.env.REACT_APP_LANG_SELECT) && (
        <span>
          <LangSelect />
        </span>
      )}
      <span>
        <UnitSelect />
      </span>
      <span>
        <PressureUnitSelect />
      </span>
      <span>
        <TimezoneSelect
          user={user}
          local={local}
          lang={currentLang}
          projectTimezone={projectTimezone}
        />
      </span>
      {/* {JSON.parse(process.env.REACT_APP_SHOW_HELP) && (
        <span>
          <a
            onClick={() => {
              downloadFile(userGuideFileName, 'manual');
            }}
          >
            {context.t('help')}
          </a>
        </span>
      )} */}
      {JSON.parse(process.env.REACT_APP_SHOW_HELP) && (
        <span>
          <UserGuideHelp triggerLabel={context.t('help')} />
        </span>
      )}
      {JSON.parse(process.env.REACT_APP_SHOW_ABOUT) && (
        <span>
          <a
            onClick={() => {
              setAboutOpen(true);
            }}
          >
            {context.t('about')}
          </a>
        </span>
      )}
      <span>
        <a
          onClick={() => {
            props.signOutFunc();
          }}
        >
          {context.t('logout')}
        </a>
      </span>

      <Dialog open={aboutOpen} onClose={() => setAboutOpen(false)}>
        <DialogTitle>
          <h1>Aquarius-Spectrum</h1>
        </DialogTitle>
        <DialogContent style={{ textAlign: 'center' }}>
          {context.t('copyright_2021_aquarius_spectrumbrbr_all_rights_re')}
          <br />
          <br />
          <a href='./certificates/notices.pdf' target='_blank'>
            {context.t('licneces')}
          </a>
        </DialogContent>
      </Dialog>
    </div>
  );
}

UserBlock.contextTypes = {
  t: PropTypes.func.isRequired,
};
